import { render, staticRenderFns } from "./ImportPage.vue?vue&type=template&id=4bea6725&scoped=true&"
import script from "./ImportPage.vue?vue&type=script&lang=js&"
export * from "./ImportPage.vue?vue&type=script&lang=js&"
import style0 from "./ImportPage.vue?vue&type=style&index=0&id=4bea6725&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bea6725",
  null
  
)

export default component.exports